<template>
  <analytics-sub-page
    title="Compare"
    icon="down-left-and-up-right-to-center"
    css-class="analytics-compare"
    default-label="Compare"
    :show-divisions-dropdown="false"
    :can-download="canDownload"
    :get-sheet-config="getSheetConfig"
  >
    <divisions-metrics ref="metricsRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import DivisionsMetrics from '@/pages/analyticsCompare/components/DivisionsMetrics.vue';

const metricsRef = ref(null);

const canDownload = () => metricsRef.value?.canDownload?.() ?? false;

const getSheetConfig = () => metricsRef.value?.getPdfData?.() || {};
</script>
